import { Configuration, ConfigurationData, SelectedConfiguration } from "@/types/crm/configuration/configuration";

export const CONFIGURATION_DEFAULT_BODY: Configuration = {
  parameter: {
    crm: [],
    project: [],
    survey: [],
    question: [],
  },
};

export const CONFIGURATION_DATA_DEFAULT_BODY: ConfigurationData = {
  parameter: {
    crm: {},
    project: {},
    survey: {},
    question: {},
  },
};

export const SELECTED_CONFIGURATION_DEFAULT_BODY: SelectedConfiguration = {
    parameter: []
}